import FullscreenOff from './FullscreenOff'

export default FullscreenOff
// eslint-disable-next-line import/export
export * from './FullscreenOff'
